import axios from "axios";

const schedulsService = {
    //horarios presenciales
    getFace(params) {
        return axios.post(`${process.env.API1}/api/scheduls/face`, params);
    },

    //aforo segun fecha de visita en base a horario
    getAforo_Date_visit(params) {
        return axios.post(`${process.env.API1}/api/scheduls/aforo-date-visit`, params);
    },

    //Fechas de visita en base al producto
    getDates_Available(params) {
        return axios.post(`${process.env.API1}/api/scheduls/available-dates`, params);
    }

}

export default schedulsService



// WEBPACK FOOTER //
// ./src/services/scheduls.service.js